// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCss from "../../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as StaticImage from "../../../StaticImage.bs.js";
import * as YearFootPrint from "./YearFootPrint.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

var container = Curry._1(BsCss.style, {
      hd: BsCss.position("absolute"),
      tl: {
        hd: BsCss.marginTop(BsCss.px(-35)),
        tl: {
          hd: BsCss.left(BsCss.px(719)),
          tl: {
            hd: BsCss.media("(min-width: 1200px)", {
                  hd: BsCss.left(BsCss.px(819)),
                  tl: /* [] */0
                }),
            tl: /* [] */0
          }
        }
      }
    });

var img = Curry._1(BsCss.style, {
      hd: BsCss.display("inlineBlock"),
      tl: {
        hd: BsCss.width(BsCss.px(100)),
        tl: {
          hd: BsCss.height(BsCss.px(45)),
          tl: /* [] */0
        }
      }
    });

var Styles = {
  container: container,
  img: img
};

function Year2020(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(StaticImage.make, {
                      src: "/images/about/journey/flag1.png",
                      alt: "flags icon",
                      width: 100,
                      height: 45,
                      className: img
                    }),
                JsxRuntime.jsx(YearFootPrint.make, {
                      title: "2020-2021",
                      subTitle: "Prezzee goes global!",
                      bodyText: "We launched in the UK, USA and New Zealand."
                    })
              ],
              className: container
            });
}

var Img;

var make = Year2020;

export {
  Img ,
  Styles ,
  make ,
}
/* container Not a pure module */
